import { Box, Button, Checkbox, Grid } from "@mui/material";
import React from "react";
import { useRecordContext } from "react-admin";
import { Controller, useForm } from "react-hook-form";
import CustomProductTextField from "../../unit/forms/CustomProductTextField";
import FieldTitle from "./FieldTitle";
import ProductLinkButton from "./ProductLinkButton";
import SectionStyled from "./SectionStyled";
import SectionTitle from "./SectionTitle";
import CustomProductActionBottom from "../CustomProductActionBottom";

const Vendor = ({ onSave, defaultValues, ...props }: any) => {
  const record = useRecordContext();

  // Constants
  const SECTION_NAME = "vendorContact";
  const SECTION_TITLE =
    "Vendor - Set requirements for vendor partners of this product";
  const SECTION_SUBTITLE = "";

  // Data extraction
  const {
    data: { basic: { vendorContact: data, productModulesGroup } = {} } = {},
  } = record || {};

  // Form initialization
  const {
    control,
    handleSubmit,
    formState: { errors, isDirty },
    reset,
    getValues,
    setValue,
    watch,
  } = useForm({
    mode: "onBlur",
    defaultValues: {
      sVendorContactName: "",
      sVendorContactEmail: "",
      sVendorPhone: "",
      useBankInfo: 0,
      ...defaultValues,
    },
  });

  // Watch form values
  const useBankInfo = watch("useBankInfo");

  // Effects
  React.useEffect(() => {
    if (data) {
      reset({
        sVendorContactName: data.sVendorContactName || "",
        sVendorContactEmail: data.sVendorContactEmail || "",
        sVendorPhone: data.sVendorPhone || "",
        useBankInfo: 0,
      });
    }
  }, [data, reset]);
  React.useEffect(() => {
    if (props?.onDirtyChange) {
      props?.onDirtyChange(props?.curMenu, isDirty);
    }
  }, [isDirty, reset]);
  // Handlers
  const handleLoadBankContact = () => {
    setValue("sVendorContactName", data?.sBankContactName || "");
    setValue("sVendorContactEmail", data?.sBankSupport || "");
    setValue("sVendorPhone", data?.sBankPhone || "");
    setValue("useBankInfo", 1);
  };

  const handleSaveClick = () => {
    const formData = getValues();
    formData.saveAction = SECTION_NAME;
    onSave?.(formData);
  };

  // Render
  if (!productModulesGroup?.includes("vendors2product")) {
    return null;
  }

  return (
    <SectionStyled id={`section_${SECTION_NAME}`}>
      <SectionTitle subtitle={SECTION_SUBTITLE} title={SECTION_TITLE} />

      <Box sx={{ padding: "10px" }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <ProductLinkButton
              title="Review and Update Vendors"
              href="/vendors"
            />
          </Grid>

          <Grid item xs={2}>
            <FieldTitle title="Vendor Contact" />
          </Grid>
          <Grid item xs={10}>
            {/* <Tooltip title="Click to load bank contact">
              <IconButton onClick={handleLoadBankContact}>
                <ReplayIcon />
              </IconButton>
            </Tooltip>
            {useBankInfo ? 1 : 0}

             */}
            {/* checkbox, use bank contact */}
            <Controller
              name="useBankInfo"
              control={control}
              render={({ field }) => (
                <Checkbox
                  {...field}
                  checked={field.value === 1}
                  onChange={(e) => {
                    field.onChange(e.target.checked ? 1 : 0);
                    if (e.target.checked) {
                      handleLoadBankContact();
                    }
                  }}
                />
              )}
            />
            Use Bank Contact
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          {renderTextField("Contact Name", "sVendorContactName", control)}
          {renderTextField("Contact Email", "sVendorContactEmail", control)}
          {renderTextField("Contact Phone", "sVendorPhone", control)}
        </Grid>

        <CustomProductActionBottom>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit(handleSaveClick)}
            disabled={!isDirty}
            sx={{ width: "120px", mt: 1 }}
          >
            Save
          </Button>
        </CustomProductActionBottom>
      </Box>
    </SectionStyled>
  );
};

// Helper component for rendering text fields
const renderTextField = (title, name, control) => (
  <>
    <Grid item xs={2}>
      <FieldTitle title={title} />
    </Grid>
    <Grid item xs={3}>
      <Controller
        name={name}
        control={control}
        render={({ field }) => <CustomProductTextField {...field} />}
      />
    </Grid>
    <Grid item xs={7} />
  </>
);

export default Vendor;
